export const KNOWN_SITE_TYPES = [
  'WordPress',
  'WiX',
  'Shopify',
  'Squarespace',
  'Weebly',
  'Leadpages',
  'Duda',
  'Google Tag Manager',
  'Other',
] as const;
export type KnownSiteType = typeof KNOWN_SITE_TYPES[number];
export const isKnownSiteType = (siteType?: string): siteType is KnownSiteType =>
  !!(siteType && KNOWN_SITE_TYPES.find(t => t === siteType));
